module.exports = __webpack_public_path__ + "media/application/images/projects/images/spain-406058416fa0f899b5c662c42c1b1593.jpg";